export function getBasicAuthToken(username: string, password: string): string {
  return Buffer.from(`${username}:${password}`).toString('base64');
}

export function getBasicAuthHeaderValue(username: string, password: string): string {
  return `Basic ${getBasicAuthToken(username, password)}`;
}
